(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecpr-product-confidence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ecprInitialized === 'true') return;
      root.dataset.ecprInitialized = 'true';

      const mainProduct = document.querySelector('[id^="Product-"]');
      const productInfo = mainProduct?.querySelector('.product-info-main');
      const mainAddButton = mainProduct?.querySelector('.button-add-to-cart');
      const priceContainer = mainProduct?.querySelector('.price');
      const supportForm = root.querySelector('[data-ecpr-support-form]');
      const requestSelect = root.querySelector('[data-ecpr-request-select]');
      const vehicleInput = root.querySelector('[data-ecpr-vehicle-input]');
      const stickyBar = root.querySelector('[data-ecpr-mobile-buybar]');
      const stickyPrice = root.querySelector('[data-ecpr-sticky-price]');

      const scrollToMainAction = () => {
        if (!mainAddButton) return;
        mainAddButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      const runMainAdd = () => {
        if (!mainAddButton || mainAddButton.disabled) {
          scrollToMainAction();
          return;
        }
        mainAddButton.click();
      };

      const openRequest = (requestType) => {
        if (requestSelect && requestType) {
          requestSelect.value = requestType;
          requestSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        supportForm?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => vehicleInput?.focus({ preventScroll: true }), 500);
      };

      root.querySelectorAll('[data-ecpr-main-add]').forEach((button) => {
        button.addEventListener('click', runMainAdd);
      });

      root.querySelectorAll('[data-ecpr-request]').forEach((button) => {
        button.addEventListener('click', () => openRequest(button.dataset.ecprRequest));
      });

      const injectProductEnhancements = () => {
        const currentMainProduct = document.querySelector('[id^="Product-"]');
        const currentProductInfo = currentMainProduct?.querySelector('.product-info-main');
        const template = root.querySelector('[data-ecpr-assurance-template]');
        const productActions = currentProductInfo?.querySelector('.product-actions');
        if (!currentProductInfo || !productActions) return;

        if (template && !currentProductInfo.querySelector('[data-ecpr-inline-assurance]')) {
          const fragment = template.content.cloneNode(true);
          productActions.insertAdjacentElement('afterend', fragment.firstElementChild);
          const inlineRequest = currentProductInfo.querySelector('[data-ecpr-inline-assurance] [data-ecpr-request]');
          inlineRequest?.addEventListener('click', () => openRequest(inlineRequest.dataset.ecprRequest));
        }

      };

      injectProductEnhancements();
      window.setTimeout(injectProductEnhancements, 300);
      window.setTimeout(injectProductEnhancements, 1200);

      if (mainProduct) {
        const injectionObserver = new MutationObserver(() => {
          window.requestAnimationFrame(injectProductEnhancements);
        });
        injectionObserver.observe(mainProduct, { childList: true, subtree: true });
      }

      if (!stickyBar || !mainAddButton) return;

      const syncStickyState = () => {
        const stickyCart = stickyBar.querySelector('[data-ecpr-main-add]');
        if (stickyCart) stickyCart.disabled = mainAddButton.disabled;
        if (stickyPrice && priceContainer) {
          const priceItems = Array.from(priceContainer.querySelectorAll('.price-item'));
          const currentPrice = priceItems.find((item) => item.offsetParent !== null) || priceItems[0];
          const visiblePrice = currentPrice?.textContent?.replace(/\s+/g, ' ').trim();
          if (visiblePrice) stickyPrice.textContent = visiblePrice;
        }
      };

      let mainActionVisible = true;
      let supportVisible = false;

      const updateStickyVisibility = () => {
        const shouldShow = window.innerWidth < 750 && window.scrollY > 240 && !mainActionVisible && !supportVisible;
        stickyBar.hidden = !shouldShow;
        stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      const actionObserver = new IntersectionObserver((entries) => {
        mainActionVisible = entries[0]?.isIntersecting ?? true;
        updateStickyVisibility();
      }, { threshold: 0.1 });

      const supportObserver = new IntersectionObserver((entries) => {
        supportVisible = entries[0]?.isIntersecting ?? false;
        updateStickyVisibility();
      }, { threshold: 0.05 });

      actionObserver.observe(mainAddButton);
      if (supportForm) supportObserver.observe(supportForm);

      const stateObserver = new MutationObserver(syncStickyState);
      stateObserver.observe(mainAddButton, { attributes: true, childList: true, subtree: true });
      if (priceContainer) stateObserver.observe(priceContainer, { childList: true, subtree: true });

      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility, { passive: true });
      syncStickyState();
      updateStickyVisibility();
    };

    document.querySelectorAll('[data-ecpr-product-confidence]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-ecpr-product-confidence]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
